import React from "react";
import { Box, Flex, Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import { searchBenefitsStyles as styles } from "../../lib/styles/search";

import Icon from "../common/Icon";

interface Props {
  isMobileViewport: boolean;
}

function Benefits({ isMobileViewport }: Props) {
  const { t } = useTranslation("search");

  const benefits = [
    {
      icon: <Icon name="vet" color="labradorBlack" fontSize={7}></Icon>,
      text: t("benefit1")
    },
    {
      icon: (
        <Icon name="cancellation" color="labradorBlack" fontSize={7}></Icon>
      ),
      text: t("benefit2")
    },
    {
      icon: <Icon name="vetted" color="labradorBlack" fontSize={7}></Icon>,
      text: t("benefit3")
    },
    {
      icon: <Icon name="support" color="labradorBlack" fontSize={7}></Icon>,
      text: t("benefit4")
    },
    {
      icon: <Icon name="secure" color="labradorBlack" fontSize={7}></Icon>,
      text: t("benefit5")
    }
  ].slice(0, isMobileViewport ? 5 : 5);

  return (
    <Box sx={styles.container}>
      {!isMobileViewport && (
        <Text as="h3" sx={styles.text}>
          {t("common:gudogBenefits")}
        </Text>
      )}

      <Flex>
        {benefits.map(benefit => {
          return (
            <Flex sx={styles.infoContainer}>
              <Box mb={1}>{benefit.icon}</Box>
              <Text textAlign="center" fontSize={["12px", "16px"]}>
                {benefit.text}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
}

export default Benefits;
